"use client";

import { useEffect, useId } from "react";

import { showToast } from "./Toast";

/**
 * A save confirmed as a notification. Mount it where the note used to sit —
 * beside the submit, on the result — and it renders nothing: the toast says
 * it and goes on its own. The message names what was saved ("Checklist
 * saved.", "Contract uploaded."): a toast has no place in the page to say it
 * for it, so a bare "Saved." would say nothing.
 *
 * `nonce` marks a fresh save that reads the same as the last (a form's new
 * result object), so saving twice says so twice. One toast per mount and
 * message: strict mode's double effect updates it rather than stacking a
 * twin.
 */
export function SavedNote({
  children,
  nonce,
}: {
  /** What was saved, as a sentence. */
  children: string;
  nonce?: unknown;
}) {
  const id = useId();
  useEffect(() => {
    showToast(children, "success", { id: `${id}:${children}` });
  }, [id, children, nonce]);
  return null;
}
